<template>
  <div>
    <div class="rownew" >
      <div class="search" >
        <input
          type="text"
          class="search-input"
          id="search-input"
          :placeholder="placeholder"
          @input="setSearchStr"
          @keyup.enter="sendsearchReq"
        />
        <span class="search-icone-wrap right">
          <img v-if="!loading" src="../../../images/dashboard/refresh.png" alt="#" @click="clear"/>
          <img v-else class="loading-gif" src="../../../images/dashboard/reloading-gif.svg" alt="Refresh" />
        </span>
        <span class="search-icone-wrap left">
          <img src="../../../images/header/search_icone.svg" alt="#" />
        </span>
      </div>
    </div>
  </div>
</template>
 
<script>
import { mapActions } from "vuex";
 
export default {
  name: "SearchCustomer",
  data() {
    return {
      inputWidth: false,
      showMenu: false,
      loading:false,
      placeholder: 'Search'
    };
  },
  methods: {
    ...mapActions([
      "setSerachString",
      "setAdminPginationPage",
      "getContactCustomers",
    ]),
    setSearchStr(e) {
      this.setAdminPginationPage(null);
      this.setSerachString(e.target.value);
    },
    async sendsearchReq() {
      this.loading = true;
      await this.setAdminPginationPage(null).then(async () => {
        await this.getContactCustomers();
      });
      this.loading = false;
    },
    clear(){
      document.getElementById("search-input").value = "";
      this.setAdminPginationPage(null).then(() => {
        this.setSerachString("").then(() => {
          this.getContactCustomers();
        });
      });
    }
  }
};
</script>
 
<style scoped>
  .rownew {
    display: flex;
    width: 100%;
    margin-top: 10%;
  }
  .search {
    max-width: 412px;
    width: 100%;
    position: absolute;
    background-color: #eee;
    border: 1px solid #eee;
    left: 0%;
    top: 0%;
    border-radius: 25px;
    transform: translate(0%, 0%);
  }
  .search-input {
    font-size: 14px;
    font-weight: 500px;
    font-family: TTNormsMedium, sans-serif;
    width: 100%;
    padding: 10px 50px;
    border: none;
    background-color: #fff;
    outline: none;
    border-radius: 5px;
    transition: all 0.5s linear;
  }
  .search-input::placeholder {
    color: #757575;
    font-family: TTNormsLight, sans-serif;
    opacity: 0.8;
  }
  .search-input:focus {
    background-color: #e3e3e3;
  }
  .search-icone-wrap {
    position: absolute;
    width: 20px;
  }
  .search-icone-wrap.right {
    right: 10px;
    top: 8px;
  }
  .search-icone-wrap.left {
    left: 30px;
    top: 10px;
  }
  .search-icone-wrap.left img {
    max-width: 70%;
    height: auto;
  }
  .search-icone-wrap.right img {
    max-width: 100%;
  }
  .loading-gif {
  width: 26px;
  height: 23.3833px;
  }
</style>
 